"use strict";
var __extends = (this && this.__extends) || function (d, b) {
    for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
    function __() { this.constructor = d; }
    d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
};
var baseComponent_1 = require("./base/baseComponent");
var ko = require("knockout");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var CommentSubscriptionComponent = (function (_super) {
    __extends(CommentSubscriptionComponent, _super);
    function CommentSubscriptionComponent(params, element, templateNodes) {
        var _this = this;
        _super.call(this, params, element, templateNodes);
        this.rootId = this.params.rootId;
        this.rootType = this.params.rootType;
        this.subscriptionId = ko.observable();
        this.isActive = ko.observable(false);
        this.toggle = function () {
            if (_this.processing())
                return;
            _this.processing(true);
            var isActive = _this.isActive();
            if (!isActive) {
                ajaxUtils_1.AjaxUtils.post("comment/subscribe", {
                    rootId: _this.rootId,
                    rootType: _this.rootType
                }).done(function (result) {
                    if (result.isSuccessful) {
                        alert("Вы подписались на уведомления о новых комментариях.");
                        _this.subscriptionId(result.data);
                        _this.isActive(true);
                    }
                    else {
                        alert(result.messages[0]);
                    }
                }).always(function () {
                    _this.processing(false);
                });
            }
            else {
                ajaxUtils_1.AjaxUtils.post("comment/unsubscribe", {
                    id: _this.subscriptionId()
                }).done(function (result) {
                    _this.subscriptionId(null);
                    if (result.isSuccessful) {
                        alert("Вы отписались от уведомлений о новых комментариях.");
                        _this.isActive(false);
                    }
                    else {
                        alert(result.messages[0]);
                    }
                }).always(function () {
                    _this.processing(false);
                });
                ;
            }
        };
        this.subscriptionId(this.params.subscriptionId);
        this.isActive(this.params.subscriptionId !== undefined
            && this.params.subscriptionId !== null);
    }
    return CommentSubscriptionComponent;
}(baseComponent_1.default));
ko.components.register("mobile-comment-subscription", {});
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = CommentSubscriptionComponent;
//# sourceMappingURL=mobileCommentSubscription.js.map